import { DateTime } from 'luxon';

export const keyOutcomesReportFilename = (from?: string, to?: string) => {
  const toDate = to || DateTime.now().toISODate();
  const dateRangeSlug = from ? `${from}-to-${toDate}` : `up-to-${toDate}`;

  return `home-visits-key-outcomes-report-${dateRangeSlug}.xlsx`;
};
